<div class="container">
  @for (item of items(); track $index) {
    <div
      class="status-chip"
      [class.status-done]="counter() > $index"
      [class.status-working]="counter() === $index"
      [class.status-pending]="counter() < $index"
    >
      @if (counter() > $index) {
        <mat-icon>check</mat-icon>
      } @else if (counter() === $index) {
        <mat-icon>circle</mat-icon>
      } @else {
        <mat-icon>nest_clock_farsight_analog</mat-icon>
      }
      <span class="mat-body-large">{{ item }}</span>
    </div>
  }
</div>
